import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { ErrorBoundary } from './pages/errors/errorFallback';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Sentry.ErrorBoundary fallback={<div>Что-то пошло не так</div>}>
        <App />
      </Sentry.ErrorBoundary>
    </ErrorBoundary>
  </React.StrictMode>,
);
